import https from '../../init/https';

//USER-INFO-12 : Check user has been to trip.
export async function CheckTrip(type, packId) {
    const checkTrip = await https.get(`/user/check/${type}/${packId}`);
    return checkTrip;
}

//USER-INFO-21 - Use coins or cash back
export async function claimCashOrCoins(data) {
    const result = await https.post(`/user/claim/back`, data);
    return result;
}
